import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Box } from '@material-ui/core';

function getWeeksAgo(dateString) {
  if (!dateString) return null;
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  return diffMs / (1000 * 60 * 60 * 24 * 7);
}

function getMostRecentAgeByBanner(data) {
  // Map: banner_name -> most recent last_collected_date
  const bannerMap = {};
  data.forEach(row => {
    const banner = row.banner_name;
    const date = row.last_collected_date;
    if (!bannerMap[banner] || new Date(date) > new Date(bannerMap[banner])) {
      bannerMap[banner] = date;
    }
  });
  // Convert to array: [{ banner, mostRecentDate, weeksAgo }]
  return Object.entries(bannerMap).map(([banner, date]) => ({
    banner,
    mostRecentDate: date,
    weeksAgo: getWeeksAgo(date),
  })).sort((a, b) => a.weeksAgo - b.weeksAgo);
}

export default function CompanyDataAgeChart({ outOfDateProducts }) {
  const dataByBanner = getMostRecentAgeByBanner(outOfDateProducts || []);
  const labels = dataByBanner.map(item => item.banner);
  const weeksAgo = dataByBanner.map(item => Number(item.weeksAgo.toFixed(2)));

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Most recent age (weeks)',
        data: weeksAgo,
        backgroundColor: '#4CAF50',
        borderRadius: 4,
        barPercentage: 0.7,
        categoryPercentage: 0.7,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: 'Most Recent Data Age (weeks) by Company Website',
        font: { size: 18 },
        padding: { bottom: 10 }
      },
      tooltip: { enabled: true },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Company Website',
          font: { size: 14 },
        },
        ticks: {
          callback: function(value, index) {
            return this.getLabelForValue(value);
          },
          maxRotation: 45,
          minRotation: 45,
          autoSkip: false,
          font: { size: 12 }
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Most recent age (weeks)',
          font: { size: 14 },
        },
        grid: { color: '#eee' },
        ticks: {
          font: { size: 12 }
        }
      },
    },
  };

  return (
    <Box sx={{ height: 'calc(100vh - 200px)', minHeight: '400px', maxHeight: '600px' }}>
      <Bar data={chartData} options={options} />
    </Box>
  );
} 